import api from './api';

/**
 * سرویس مدیریت ملاقات‌ها
 * شامل CRUD عملیات برای ملاقات‌ها
 */

// دریافت لیست ملاقات‌ها
export const getAppointments = async (params = {}) => {
  try {
    const response = await api.get('/appointments', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت اطلاعات یک ملاقات خاص
export const getAppointmentById = async (appointmentId) => {
  try {
    const response = await api.get(`/appointments/${appointmentId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// ایجاد ملاقات جدید (فقط برای مدیران)
export const createAppointment = async (appointmentData) => {
  try {
    const response = await api.post('/appointments', appointmentData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// بروزرسانی ملاقات (مشاوران می‌توانند وضعیت و یادداشت‌ها را تغییر دهند)
export const updateAppointment = async ({ appointmentId, appointmentData, isAdmin = false }) => {
  try {
    let endpoint = `/appointments/${appointmentId}`;
    
    // اگر مدیر است، از endpoint مخصوص مدیران استفاده کن
    if (isAdmin) {
      endpoint = `/appointments/${appointmentId}/admin`;
    }
    
    console.log('Sending update request to:', endpoint);
    console.log('Update data:', appointmentData);
    const response = await api.put(endpoint, appointmentData);
    console.log('Update response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Update appointment error:', error);
    throw error.response?.data || error.message;
  }
};

// لغو ملاقات (فقط برای مدیران)
export const cancelAppointment = async (appointmentId) => {
  try {
    const response = await api.delete(`/appointments/${appointmentId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
export const scheduledAppointment = async (appointmentId) => {
  try {
    const response = await api.put(`/appointments/${appointmentId}/scheduled`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت ملاقات‌های یک مشاور خاص
export const getAppointmentsByConsultant = async (consultantId) => {
  try {
    const response = await api.get(`/appointments/consultant/${consultantId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت ملاقات‌های یک مراجع خاص
export const getAppointmentsByClient = async (clientId) => {
  try {
    const response = await api.get(`/appointments/client/${clientId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// بررسی تداخل زمانی برای ملاقات
export const checkAppointmentConflict = async (appointmentData) => {
  try {
    const response = await api.post('/appointments/check-conflict', appointmentData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت جزئیات ملاقات با فایل‌ها و یادداشت مشاور
export const getAppointmentDetails = async (appointmentId) => {
  try {
    const response = await api.get(`/appointments/${appointmentId}/details`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// اضافه کردن فایل به ملاقات
export const addFileToAppointment = async (appointmentId, fileId) => {
  try {
    const response = await api.post(`/appointments/${appointmentId}/add-file`, { fileId });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// به‌روزرسانی یادداشت مشاور
export const updateConsultantNotes = async ({ appointmentId, consultantNotes, companionName, companionRelation }) => {
  try {
    const updateData = { consultantNotes };
    
    // اضافه کردن فیلدهای جدید اگر موجود باشند
    if (companionName !== undefined) {
      updateData.companionName = companionName;
    }
    if (companionRelation !== undefined) {
      updateData.companionRelation = companionRelation;
    }
    
    const response = await api.put(`/appointments/${appointmentId}`, updateData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}; 